/**
 * DetailSynopsisArrowContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled container for the detail synopsis arrow element.
 */
const DetailSynopsisArrowContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  position: absolute;
  height: ${96 * Screen.widthRatio}px;
  justify-content: space-between;
  padding: ${12 * Screen.widthRatio}px 0;
  left: ${994 * Screen.widthRatio}px;
`;
export default withOpacity(DetailSynopsisArrowContainer);
